import { render, staticRenderFns } from "./RequestsWithoutResut.vue?vue&type=template&id=2a0b1bad&"
import script from "./RequestsWithoutResut.vue?vue&type=script&lang=js&"
export * from "./RequestsWithoutResut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports